<template>
    <CardPage :section="15" :page="6" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            You are mastering this! You’ve earned another sticker for thinking about your boundaries.
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section15/sticker')
    },
    methods: {
        finish() {
            this.$store.set('section15/complete', true);
            this.$store.set('section15/sticker@earned', true);
        }
    }
};
</script>
